import { ChannelMessage_Post_Content_Text } from '@towns-protocol/proto'
import { isDefined, transformAttachments, type UnfurledLinkAttachment } from '@towns-protocol/sdk'
import { getUnfurlContent, type UnfurledLink } from 'api/lib/unfurl'

export const unfurlLinksToAttachments = async (
    pending: string[],
    payload: ChannelMessage_Post_Content_Text,
) => {
    let response
    let retryCount = 0
    const maxRetries = 2

    while (retryCount <= maxRetries) {
        try {
            response = await getUnfurlContent(pending)
            break
        } catch (error) {
            retryCount++
            if (retryCount > maxRetries) {
                console.error('Failed to unfurl links after retries:', error)
                return
            }
            await new Promise((resolve) => setTimeout(resolve, 1000 * retryCount))
        }
    }

    const data = response?.data

    if (!Array.isArray(data)) {
        return
    }

    const unfurledLinks = data as UnfurledLink[]

    for (const unfurledValue of unfurledLinks) {
        if (!isDefined(unfurledValue)) {
            continue
        }
        const miniappInfo =
            unfurledValue.type === 'miniapp' && 'info' in unfurledValue
                ? unfurledValue.info
                : undefined

        const unfurl: UnfurledLinkAttachment = {
            type: 'unfurled_link',
            url: unfurledValue.url,
            title: unfurledValue.title ?? '',
            description: unfurledValue.description ?? '',
            image: unfurledValue.image,
            id: unfurledValue.url,
        }

        if (miniappInfo) {
            unfurl.info = JSON.stringify(miniappInfo)
        }

        const attachmentIndex = payload.attachments?.findIndex(
            (a) => a.content.case === 'unfurledUrl' && unfurl.url === a.content.value.url,
        )

        if (attachmentIndex > -1) {
            const transformedAttachments = transformAttachments([unfurl])
            payload.attachments[attachmentIndex] = transformedAttachments[0]
        }
    }
}
